import {
  AnnouncementStatus,
  DateFormatDay,
  DateFormatFull,
  DateFormatMonthDay,
  DocumentStatus,
  MEMBERSHIP_STATUS,
} from '@pya-mms/common';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { ChipColors } from '../theme';
dayjs.extend(relativeTime);

export type DateFormat = 'DATE' | 'DATE_MINUTES' | 'DAY_MONTH' | 'DATE_LONG';

export const DateToString = (date: Date, format: DateFormat = 'DATE', onMinDate?: string) => {
  if (onMinDate && dayjs(date).toDate().getTime() === 0) return onMinDate;
  if (format === 'DATE') return dayjs(date).format(DateFormatDay);
  if (format === 'DAY_MONTH') return dayjs(date).format(DateFormatMonthDay);
  if (format === 'DATE_LONG') return dayjs(date).format('D MMMM YYYY');
  return dayjs(date).format(DateFormatFull);
};

export const DateAgo = (date: Date, isAdmin = false) => {
  const d = dayjs(date);

  if (isAdmin) {
    return d.format('DD/MM/YY HH:mm');
  }

  const now = dayjs();
  const diffInHours = now.diff(d, 'hour');
  const diffInDays = now.diff(d, 'day');

  if (diffInHours < 24) {
    return d.fromNow();
  }
  if (diffInDays < 7) {
    return d.format('ddd HH:mm');
  }
  return d.format(DateFormatDay);
};
/**
 * Adds a currency symbol to a number value
 * @param value
 * @param currencyCode
 * @returns formatted string
 */
export const numberFormat = (value: number, currencyCode = 'EUR') =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(value);

export const formatFileSize = (fileSizeInKB: number) => {
  // Define suffixes for different file size units
  const units = ['KB', 'MB', 'GB', 'TB'];

  // Initialize variables
  let size = fileSizeInKB;
  let unitIndex = 0;

  // Convert the file size to higher units until it's less than 1024
  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  // Round to two decimal places
  size = Math.round(size * 100) / 100;

  // Return the formatted file size with the appropriate unit
  return size + ' ' + units[unitIndex];
};

export const getAnnouncementStatusChipColor = (status: AnnouncementStatus | string): ChipColors => {
  if (status === AnnouncementStatus.Published) return 'green';
  if (status === AnnouncementStatus.Archived) return 'info';
  return 'gray';
};

export const getDocumentChipColorByStatus = (status: string): ChipColors => {
  if (status === DocumentStatus.DECLINED) return 'red';
  if (status === DocumentStatus.VERIFIED) return 'green';
  if (status === DocumentStatus.UNDER_REVIEW) return 'info';
  if (status === DocumentStatus.SIGHTED) return 'yellow';
  if (status === DocumentStatus.APPROVED) return 'green';
  if (status === DocumentStatus.EXCLUDED) return 'yellow';
  return 'gray';
};
export const getMembershipChipColor = (Status: MEMBERSHIP_STATUS): ChipColors =>
  Status === MEMBERSHIP_STATUS.PAID ? 'green' : Status === MEMBERSHIP_STATUS.PENDING ? 'yellow' : 'red';

export const fullName = (firstName: string, lastName: string, middleName?: string | null) => {
  return `${firstName} ${middleName ? `${middleName} ` : ''} ${lastName}`;
};
